import React, { useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./VideoGallery.css"; 

const videosData = [
  {
    youtubeId: "I0wzEwazo6U",
    description: "Essential Financial Risk Strategies for MSBs | Expert Advice from MWE Advisors",
  },
  {
    youtubeId: "msHC3uy8LXM",
    description: "Future of CASH, MSB Bank & AI: Game-Changing Talk by Vishal Patil",
  },
  {
    youtubeId: "S7ZBXJCYvyc",
    description: "“Do's & Don'ts to get a bank account for your MSB business",
  },
  {
    youtubeId: "K6cKEOm1bWo",
    description: "“It was a powerful moment of connection.” – Mr. Sampaio Marques",
  },
  {
    youtubeId: "X6KvYtkHGQ8",
    description: "“I left the event with new ideas and real connections.” – Mr. Joseph Nwajei",
  },
  {
    youtubeId: "F9UMlZv35kQ",
    description: "“The MSB Meetup felt like a turning point.” – Mrs. Bosede Adeniyi",
  },
  {
    youtubeId: "xskm0gqOufI",
    description: "A Glimpse from the First MSB Association Meetup",
  },
  {
    youtubeId: "iIr0QE_1gx4",
    description: "Welcome Meet - London 2025",
  },
  {
    youtubeId: "isiLkJtn20w",
    description: "How Email & Mobile Verification Can Cut Customer Onboarding Costs.",
  },
];

const VideoThumbnail = ({ youtubeId, onClick, index }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  const thumbnailVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.div
      ref={ref}
      className="col-lg-4 col-md-6 col-sm-12 mb-4 d-flex justify-content-center"
      variants={thumbnailVariants}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      onClick={onClick}
    >
      <div className="video-thumbnail-container">
        <img
          src={`https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`}
          alt="Video thumbnail"
          className="img-fluid gallery-thumb"
        />
        <div className="play-icon">
          <i className="fa-solid fa-play"></i>
        </div>
      </div>
    </motion.div>
  );
};

const Videogallery2025 = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openModal = (index) => {
    setCurrentIndex(index);
    setModalOpen(true);
  };

  const closeModal = () => setModalOpen(false);

  const showNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev + 1) % videosData.length);
  };

  const showPrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev - 1 + videosData.length) % videosData.length);
  };

  const title = "Video Gallery 2025";
  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: { delay: index * 0.05, duration: 0.4, ease: "easeInOut" },
    }),
  };

  return (
    <>
      <Helmet>
        <title>Video Gallery 2025 | Money Service Business Advocacy UK</title>
        <meta name="description" content="View videos from the 2025 MSB Advocacy UK event, including expert talks, networking highlights, and more." />
      </Helmet>

      <main className="page_content">
        <section className="page_header text-center section_decoration" style={{ background: "#333", position: "relative", padding: "" }}>
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}
            >
              {title.split("").map((letter, index) => (
                <motion.span
                  key={index}
                  custom={index}
                  variants={letterVariants}
                  style={{ display: "inline-block", whiteSpace: "pre-wrap" }}
                >
                  {letter}
                </motion.span>
              ))}
            </motion.h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="active">
                <a href="#!">Video Gallery 2025</a>
              </li>
            </ul>
          </div>
        </section>

        <style jsx>{`
          .page_header {
            padding: 120px 0 60px;
          }
          @media (max-width: 768px) {
            .page_header {
              padding: 100px 0 40px;
            }
            .page_title {
              font-size: 32px !important;
              line-height: 1.2 !important;
            }
          }
          @media (max-width: 480px) {
            .page_title {
              font-size: 26px !important;
            }
          }
        `}</style>

        <section className="service_section section_space" style={{ overflow: "hidden" }}>
          <div className="container">
            <div className="row align-items-center mt-5 justify-content-center">
              {videosData.map((video, index) => (
                <VideoThumbnail
                  key={video.youtubeId}
                  youtubeId={video.youtubeId}
                  index={index}
                  onClick={() => openModal(index)}
                />
              ))}
            </div>
          </div>
        </section>

        {modalOpen && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="video-responsive">
                <iframe
                  width="853"
                  height="450"
                  src={`https://www.youtube.com/embed/${videosData[currentIndex].youtubeId}?autoplay=1&rel=0`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Embedded youtube"
                />
              </div>

              {videosData[currentIndex].description && (
                <p className="modal-description">
                  {videosData[currentIndex].description}
                </p>
              )}

              <button className="modal-close" onClick={closeModal}>×</button>
              <button className="modal-prev" onClick={showPrev}>❮</button>
              <button className="modal-next" onClick={showNext}>❯</button>
            </div>
          </div>
        )}
      </main>
    </>
  );
};

export default Videogallery2025;
